import clsx from 'clsx';
import { FC, ReactNode } from 'react';

interface Props {
  items: ReactNode[];
  style?: string;
  gap?: 'sm' | 'base' | 'lg';
  depth?: 0 | 1 | 2;
  className?: string;
}

export const OrderedList: FC<Props> = ({
  items,
  style = '*.',
  gap = 'base',
  depth = 0,
  className,
}) => (
  <div className={className}>
    <div className={clsx('flex flex-col', getGap(gap))}>
      {items.map((item, index) => (
        <div key={index} className="flex gap-3">
          <p className={clsx('font-outfit', getFontSize(depth))}>
            {style.replace('*', (index + 1).toString())}
          </p>
          <div className={getPaddingTop(depth)}>{item}</div>
        </div>
      ))}
    </div>
  </div>
);

const getGap = (gap: 'sm' | 'base' | 'lg') =>
  ({
    sm: 'gap-2',
    base: 'gap-5',
    lg: 'gap-8',
  }[gap]);

const getFontSize = (depth: 0 | 1 | 2) => {
  switch (depth) {
    case 0:
      return 'text-xl';
    case 1:
      return 'text-base';
    case 2:
      return 'text-sm';
  }
};

const getPaddingTop = (depth: 0 | 1 | 2) => {
  switch (depth) {
    case 0:
      return 'pt-1';
    case 1:
      return 'pt-[2px]';
    case 2:
      return 'pt-0';
  }
};
